import { isUndNullEmp } from '../../helpers/main.js';

export class DigitizedDocument {
    constructor(
        _company = {
            name: '',
            id: 0,
            rif: '',
            secundaryId: '',
        },
        _description = '',
        _emisionDate = '',
        _expirationDate = '',
        _item = {
            id: '',
            description: '',
        },
        _name = '',
        _number = 0,
        _numberStr = '',
        _rowNumber = 0,
        _service = {
            commentary: '',
            dns: '',
            endDate: new Date(),
            endDateStr: '',
            remainingDays: 0,
        },
        _type = '',
        _urlDownload = '',
    ) {
        this.company = _company;
        this.description = _description;
        this.emisionDate = _emisionDate;
        this.expirationDate = _expirationDate;
        this.item = _item;
        this.name = _name;
        this.number = _number;
        this.numberStr = _numberStr;
        this.rowNumber = _rowNumber;
        this.service = _service;
        this.type = _type;
        this.urlDownload = _urlDownload;
    }

    static getClassName = () => {
        return 'Digitized document - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Company: {
                        Id: 1,
                        Name: 1,
                        SecundaryId: 1,
                        Rif: 1,
                    },
                    Description: 10,
                    EmisionDate: 10,
                    ExpirationDate: 10,
                    Item: {
                        Id: 1,
                        Description: 1,
                    },
                    Name: 1,
                    Number: 0,
                    NumberStr: 0,
                    RowNumber: 0,
                    Service: {
                        Commentary: 0,
                        Dns: 0,
                        EndDate: 10,
                        EndDateStr: 0,
                        RemainingDays: 0,
                    },
                    Type: 0,
                    UrlDonwload: 0,
                },
                max: {
                    Company: {
                        Id: 450,
                        Name: 450,
                        SecundaryId: 20,
                        Rif: 20,
                    },
                    Description: 450,
                    EmisionDate: 100,
                    ExpirationDate: 100,
                    Item: {
                        Id: 450,
                        Description: 450,
                    },
                    Name: 100,
                    Number: 450,
                    NumberStr: 450,
                    RowNumber: 450,
                    Service: {
                        Commentary: 450,
                        Dns: 450,
                        EndDate: 10,
                        EndDateStr: 10,
                        RemainingDays: 10,
                    },
                    Type: 100,
                    UrlDonwload: 450,
                }
            };
        } else {
            return {
                min: {
                    company: {
                        id: 1,
                        name: 1,
                        secundaryId: 1,
                        rif: 1,
                    },
                    description: 450,
                    emisionDate: 10,
                    expirationDate: 10,
                    item: {
                        id: 1,
                        description: 1,
                    },
                    name: 1,
                    number: 0,
                    numberStr: 0,
                    rowNumber: 0,
                    service: {
                        commentary: 0,
                        dns: 0,
                        endDate: 10,
                        endDateStr: 0,
                        remainingDays: 0,
                    },
                    type: 0,
                    urlDownload: 0,
                },
                max: {
                    company: {
                        id: 450,
                        name: 450,
                        secundaryId: 20,
                        rif: 20,
                    },
                    description: 100,
                    emisionDate: 100,
                    expirationDate: 100,
                    item: {
                        id: 450,
                        description: 450,
                    },
                    name: 100,
                    number: 450,
                    numberStr: 450,
                    rowNumber: 450,
                    service: {
                        commentary: 450,
                        dns: 450,
                        endDate: 10,
                        endDateStr: 10,
                        remainingDays: 10,
                    },
                    type: 100,
                    urlDownload: 450,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new DigitizedDocument(
                    obj.Company,
                    obj.Description,
                    obj.EmisionDate,
                    obj.ExpirationDate,
                    obj.Item,
                    obj.Name,
                    obj.Number,
                    obj.NumberStr,
                    obj.RowNumber,
                    obj.Service,
                    obj.Type,
                    obj.UrlDonwload,
                );
            } else {
                return new DigitizedDocument(
                    obj.company,
                    obj.description,
                    obj.emisionDate,
                    obj.expirationDate,
                    obj.item,
                    obj.name,
                    obj.number,
                    obj.numberStr,
                    obj.rowNumber,
                    obj.service,
                    obj.type,
                    obj.urlDownload,
                );
            }
        } else {
            return new DigitizedDocument();
        }
    }
}